/*
 Настройки pointer-драга для левого списка аналитики.

 Список работает на TouchBackend с поддержкой мыши, а не на нативном HTML5-драге:
 спецификация требует подавлять ввод на всё время нативного drag-and-drop, поэтому
 колесо мыши до страницы не доходит и список при перетаскивании не прокрутить.
 Без нативной drag-сессии колесо работает штатно на любой платформе.

 Остальные списки проекта, то есть формулы, выбранные столбцы и редактор складов,
 остаются на нативном драге, и у них свой общий менеджер DnD.
*/

export const pointerDndOptions = {
  enableMouseEvents: true,
  enableTouchEvents: true,
  // Для мыши задержки быть не должно: точку старта бэкенд фиксирует только после
  // таймаута, а до этого движения достаются выделению текста, а не переносу. Клик от
  // переноса отделяет touchSlop: пока смещение меньше порога, это обычный клик.
  delayMouseStart: 0,
  touchSlop: 5,
  // Пальцу задержка нужна, иначе список нельзя будет прокрутить свайпом.
  delayTouchStart: 150,
  ignoreContextMenu: true,
};
